export const iconFontAwesomeConstructionRulerVertical = (
	<i className="fa-solid fa-ruler-vertical"></i>
);
